// extracted by mini-css-extract-plugin
export default {"mainPanel":"PictureOrVideo_mainPanel__5--ym","pictureorvideo":"PictureOrVideo_pictureorvideo__OcQXB"};